import * as React from 'react'
const Iframe = (props) => {

    return (
        <>
        <iframe id="vid_frame" src={props.source} title={props.title} width="560" height="315"></iframe>
        </>
    )
}

export default Iframe
